import SectionHeading from "./SectionHeading";
import { featuredNews, newsList } from "@/mocks/news";

export default function News() {
  return (
    <section id="news" className="w-full px-4 py-16 md:px-8 md:py-24">
      <SectionHeading
        eyebrow="动漫资讯"
        title="新番动态与观察速览"
        description="从排期、口碑到前瞻，把与追番直接相关的信息整理成短阅读，几分钟掌握重点。"
      />

      <div className="mt-9 grid gap-6 lg:grid-cols-2">
        <article className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="aspect-[16/9] w-full overflow-hidden bg-background-100">
            <img
              src={featuredNews.image}
              alt={featuredNews.alt}
              className="h-full w-full object-top"
            />
          </div>
          <div className="p-5 md:p-6">
            <div className="flex items-center gap-3 text-xs">
              <span className="rounded-full bg-primary-100 px-2.5 py-1 text-primary-700">
                {featuredNews.category}
              </span>
              <span className="text-foreground-500">{featuredNews.date}</span>
            </div>
            <h3 className="mt-3 text-xl leading-snug text-foreground-950">{featuredNews.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              {featuredNews.summary}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-primary-700">
              <i className="ri-article-line" />
              头条观察
            </p>
          </div>
        </article>

        <div className="flex flex-col gap-4">
          {newsList.map((item) => (
            <article
              key={item.title}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 sm:flex-row sm:items-start"
            >
              <div className="flex shrink-0 flex-col items-start gap-2 sm:w-24">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900">
                  {item.category}
                </span>
                <span className="text-[11px] text-foreground-500">{item.date}</span>
              </div>
              <div className="min-w-0">
                <h3 className="text-base leading-snug text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}